
import React from "react";
import { Button } from "@/components/ui/button";
import { Save, Send } from "lucide-react";

interface TutorialActionButtonsProps {
  isSubmitting: boolean;
  isUserLoggedIn: boolean;
  onSaveDraft: () => void;
  onSubmitForReview: () => void;
}

const TutorialActionButtons: React.FC<TutorialActionButtonsProps> = ({
  isSubmitting,
  isUserLoggedIn,
  onSaveDraft,
  onSubmitForReview
}) => {
  return (
    <div className="flex gap-4 justify-end">
      <Button variant="secondary" onClick={onSaveDraft} disabled={isSubmitting}>
        <Save size={16} className="mr-2" />
        Save Draft
      </Button>
      <Button 
        variant="default"
        onClick={onSubmitForReview} 
        disabled={isSubmitting || !isUserLoggedIn}
      >
        <Send size={16} className="mr-2" />
        {isSubmitting ? "Submitting..." : "Submit for Review"}
      </Button>
    </div>
  );
};

export default TutorialActionButtons;
